import React, { Fragment, useCallback, useRef, useState } from "react";
import { useAuth } from "../../../../hooks/AuthenticateContext";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { toast } from "sonner";
import PlusButtonIcon from "../../../../assets/images/PlusButtonIcon.svg";
import Grid from "../../../../components/Grid";
import { GridHandle } from "../../../../components/Grid/model/Grid";
import Loading from "../../../../core/common/Loading";
import ModalDelete from "../../../../components/ModalDelete";
import { formatDateTimeBR } from "../../../../helpers/format";
import api from "../../../../services/api";
import { FrontendNotification } from "../../../../shared/Notification";
import { ITransportadorasVeiculos } from "./types/types";
import Create from "./Create";
import Info from "./Info";
import Can from "../../../../components/Can";

const Veiculos: React.FC = () => {
  const { user } = useAuth();
  const [selectedRow, setSelectedRow] = useState<ITransportadorasVeiculos>();
  const [isView, setIsView] = useState(false);
  const [isRemove, setIsRemove] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showCreate, setShowCreate] = useState(false);

  const defaultColumns = [
    {
      field: "placa_dianteira_veiculo",
      fieldName: "placa_dianteira_veiculo",
      headerName: "Placa Dianteira",
      filter: true,
      valueFormatter: (params: any) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: any) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "data_historico",
      headerName: "Data do Histórico",
      flex: 1,
      valueFormatter: (params: any) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }

        return "---";
      },
    },
  ];


  const gridRef = useRef<GridHandle>(null);

  const defaultFilters = {
    id_transportadora: user?.id_transportadora,
  }

  const onDelete = useCallback(async (rowId?: number) => {
    try {
      setLoading(true);

      const userId = user?.id;

      const body = {
        id_transportadora_veiculo: rowId,
        id_usuario_historico: userId,
      };

      console.log("Passou", body);

      toast.success("Veiculo removido com sucesso!")

      await api.post("/deletar/transportadorasVeiculos", body);

      FrontendNotification("Veiculo removido com sucesso!", "success")

      setLoading(false);

      gridRef.current?.api?.refreshCells({
        force: true,
      })

    } catch {
      setLoading(false);
    }
  }, [user]);

  return (
    <Fragment>

      {showCreate && (
        <Create
          isEdit={isEdit}
          isView={isView}
          selectedRow={selectedRow}
          onClear={() => setShowCreate(false)}
          onConfirm={() => {
            setShowCreate(false);
            gridRef.current?.refresh();
          }}
          id_transportadora={Number(user?.id_transportadora)}
        />
      )}
      
      {isRemove && (
        <ModalDelete
          isOpen={isRemove}
          title="Deseja desativar o veiculo?"
          message="Por favor, confirme que você deseja desativar o veiculo dessa transportadora:"
          onCancel={() => setIsRemove(!isRemove)}
          onConfirm={() => {
            setIsRemove(!isRemove)
            onDelete(selectedRow?.id_transportadora_veiculo)
          }}
          row={String(selectedRow?.placa_dianteira_veiculo)}
        />
      )}

      {isView && (
        <Info
          data={selectedRow}
          title="Conhecer - Transportadoras Veículos"
          onClose={() => setIsView(!isView)}
        />
      )}

      <Loading loading={loading} />

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">Veículos</h1>
          </div>
          <div className="mr-14">
            <Can acao="SALVAR">
            <button
              className="flex items-center justify-center h-12 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full"
              onClick={() => setShowCreate(!showCreate)}
              id="btnCreate"
            >
              Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
            </button>
            </Can>
          </div>
        </div>
        <div className="flex w-[calc(100vh - 90px)]">
          <Grid
            ref={gridRef}
            columns={defaultColumns}
            filters={[]}
            customFilters={defaultFilters}
            pagination
            path="/listar/transportadorasVeiculos"
            onDelete={(data: ITransportadorasVeiculos) => {
              setIsRemove(!isRemove);
              setSelectedRow(data);
            }}
            status={[]}

            onView={(data: ITransportadorasVeiculos) => {
              setSelectedRow(data);
              setIsView(!isView);
            }}
            onUpdate={(data: ITransportadorasVeiculos) => {
              setSelectedRow(data);
              setIsEdit(!isEdit);
              setShowCreate(!showCreate);
            }}
          />
        </div>
      </div>


    </Fragment>
  );

};
export default Veiculos;
